import { alpha, darken, Theme } from "@mui/material/styles";
import { Perfil } from "../../../pages/easyReport/perfilRelatorio/Index";

export const useStyle = (
  theme: Theme,
  selectedPerfil: Perfil | null,
  perfil: Perfil,
) => ({
  titleCard: {
    fontSize: "1rem",
    fontWeight: 500,
    color:
      theme.palette.mode == "dark"
        ? theme.palette.primary.main
        : darken(theme.palette.primary.main, 0.1),
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    flex: 1,
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
      //marginBottom: 2,
    },
  },
  descriptionCard: {
    fontSize: "0.85rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    padding: 1,
    height: "80px",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "5px",
    marginBottom: 1,
    border:
      selectedPerfil?.id == perfil?.id
        ? "2px solid " + theme.palette.primary.main
        : "1px solid " + theme.palette.color.stroke,
    backgroundColor: theme.palette.background.cardProfile,
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    "&:hover": {
      backgroundColor:
        selectedPerfil?.id == perfil?.id
          ? alpha(theme.palette.primary.main, 0.07)
          : alpha(theme.palette.text.secondary, 0.05),
      cursor: "pointer",
    },
  },
  bar: {
    height: "100%",
    width: "5px",
    borderRadius: "18px",
    mr: 2,
    background:
      selectedPerfil?.id == perfil?.id
        ? theme.palette.primary.main
        : theme.palette.background.chipCard,
  },
  textBox: {
    display: "flex",
    flex: 1,
    minWidth: 0,
    gap: 0,
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
  },
  iconBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    width: "100%",
    justifyContent: "flex-end",
    marginTop: 2,
  },
});
